export default __webpack_public_path__ + "static/media/dtsu5168_ct_gw152.d0ee7631.png";